import { useEffect } from 'react';
import { useTerminalStore, type Toast } from '../store/useTerminalStore';

const ICON: Record<Toast['type'], string> = {
  info: '●',
  success: '✓',
  warning: '▲',
  error: '✕',
};

const COLOR: Record<Toast['type'], string> = {
  info: 'border-l-primary text-primary',
  success: 'border-l-success text-success',
  warning: 'border-l-warning text-warning',
  error: 'border-l-danger text-danger',
};

function ToastItem({ toast }: { toast: Toast }) {
  const removeToast = useTerminalStore((s) => s.removeToast);

  useEffect(() => {
    const timer = setTimeout(() => removeToast(toast.id), 5000);
    return () => clearTimeout(timer);
  }, [toast.id, removeToast]);

  return (
    <div className={`flex items-start gap-2 bg-card border border-border border-l-2 ${COLOR[toast.type]} rounded-sm px-3 py-2 shadow-lg animate-fade-up`}>
      <span className="text-[10px] font-mono mt-0.5">{ICON[toast.type]}</span>
      <span className="text-[9px] font-mono text-foreground flex-1">{toast.message}</span>
      <button
        onClick={() => removeToast(toast.id)}
        className="text-[9px] font-mono text-muted hover:text-foreground ml-2"
      >
        ✕
      </button>
    </div>
  );
}

export function ToastContainer() {
  const toasts = useTerminalStore((s) => s.toasts);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-10 right-4 z-50 flex flex-col gap-1.5 w-72">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
